/**
 * @generated SignedSource<<bc216e186cde154b3c00b5cab03fe0b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTodoOverviewPreview_widget$data = {
  readonly category: {
    readonly id: string;
    readonly title: string;
  } | null;
  readonly id: string;
  readonly teams: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverviewListPaginated">;
  readonly " $fragmentType": "WidgetTodoOverviewPreview_widget";
};
export type WidgetTodoOverviewPreview_widget$key = {
  readonly " $data"?: WidgetTodoOverviewPreview_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverviewPreview_widget">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTodoOverviewPreview_widget",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTodoOverviewListPaginated"
    }
  ],
  "type": "WidgetTodoOverview",
  "abstractKey": null
};
})();

(node as any).hash = "62c32207ae5bffe39efe50259be09b4b";

export default node;
